'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../sections/product');

document.addEventListener('DOMContentLoaded', function () {
  (0, _themeSections.load)('*');
});